<template>
   <span class="icon-wrap icon-circle" :style="styles">
    <img v-if="avatar" :src="avatar" class="img-circle">
    <img v-else :src="`${this.staticUrl}/v4/fontawesome-pro-5.3.1/svg/user-circle.svg`" class="img-svg img-circle">
  </span>
</template>

<script>
  export default {
    name: 'ProfilePic',

    props: {
      'avatar': {
        'type': String,
        'default': null
      },
      'size': {
        'type': String,
        'default': 'small'
      },
      'styles': {
        'type': Object,
        'default': () => ({'backgroundColor': this.colour})
      }
    }
  }
</script>

<style scoped lang="less">

   span {
      height: 60%;
      width: 44%;
      margin-top: 14%;
      position:absolute;
      margin-left: -22%;
      padding: 1.5%;

      img {
        height: 94%;
        width: 94%;
        position: absolute;
        left: 3%;
        top: 3%;

        &.img-svg {
          height: 95%;
          width: 95%;
          /*margin-left: -2%;*/
          /*margin-top: -2%;*/
          left: 2.5%;
          top: 2.5%;
        }
      }
    }
</style>
